import { ApplicationView, useController } from '@aha-app/mvc';
import React from 'react';
import PresentationController from '../controllers/PresentationController';
import customElementBoolAttr from '../utils/customElementBoolAttr';
import styles from './presentations.module.css';

const SidePanelHeader: React.FC = () => {
  const controller = useController(PresentationController);

  return (
    <div className={styles.presentButtonWrap}>
      <aha-button
        kind='primary'
        onClick={() => controller.actionStartPresenting()}
        disabled={customElementBoolAttr(!controller.canPresent())}
      >
        Present
        <i className='fa-solid fa-play' />
      </aha-button>
    </div>
  );
};

export default ApplicationView(SidePanelHeader);
